export default __webpack_public_path__ + "static/media/banner_food.38562ea2.png";